const FRONTEND_VERSION = import.meta.env.VITE_APP_VERSION || '1.3.1'
const DEBOUNCE_TIME = 30 * 1000 // 30 秒防抖

let lastCheckTime = 0
let lastServerVersion = null

/**
 * 從響應頭檢查版本是否一致
 * 此函數適合在響應攔截器中使用，會自動使用防抖機制避免過於頻繁檢查
 * @param {Object} response - axios 響應對象
 * @returns {boolean} 返回 true 表示版本一致，false 表示不一致
 */
export function checkVersionFromResponse(response) {
  // 防抖：如果距離上次檢查不到 30 秒，跳過
  const now = Date.now()
  if (now - lastCheckTime < DEBOUNCE_TIME && lastCheckTime > 0) {
    // 如果之前已經檢查過且版本一致，直接返回 true
    if (lastServerVersion === FRONTEND_VERSION) {
      return true
    }
    // 如果之前檢查過版本不一致，直接返回 false
    if (lastServerVersion && lastServerVersion !== FRONTEND_VERSION) {
      return false
    }
    // 如果之前沒有檢查過，繼續檢查
  }

  // 從響應頭獲取服務器版本號
  const serverVersion = response?.headers?.['x-app-version'] || 
                       response?.headers?.['X-App-Version']
  
  if (!serverVersion) {
    // 如果響應頭中沒有版本號，視為版本一致（可能是舊版本後端或靜態資源）
    return true
  }

  // 更新最後檢查時間和服務器版本
  lastCheckTime = now
  lastServerVersion = serverVersion

  // 比較版本號
  const isMatch = serverVersion === FRONTEND_VERSION
  
  if (!isMatch) {
    // 版本不一致
    return false
  }
  
  return true
}

/**
 * 獲取前端版本號
 */
export function getFrontendVersion() {
  return FRONTEND_VERSION
}

